import { render, staticRenderFns } from "./TextObjectDrawer.vue?vue&type=template&id=5a9049a8&"
import script from "./TextObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./TextObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports